import { React, useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import "./purchase-detail-style.css";
import Loading from "../../dialog/loading/loading";
import UserService from "../../../service/user-service";
import SiteFooter from "../../custom/site-footer/site-footer";
import useIsMobile from "../../../hooks/useIsMobile";

const STATUS_LABEL = {
  pending: "待付款",
  paid: "已完成",
  failed: "付款失敗",
};

//planID → 商品圖片
const PLAN_IMAGE = {
  digital_flow: "/images/bg-flow-book.png",
  digital_love: "/images/bg-love-match.png",
  digital_chart: "/images/bg-personal-question.png",
  digital_family: "/images/bg-personal-question.png",
};
const getProductImage = (planID) =>
  PLAN_IMAGE[planID] || "/images/bg-personal-question.png";

const pad = (n) => String(n).padStart(2, "0");
const formatTime = (ts) => {
  if (!ts) return "—";
  const d = new Date(ts);
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(
    d.getDate()
  )} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const PurchaseDetailCompontent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  //訂單編號：優先取 URL query（重新整理仍保留），其次 router state
  const orderID = String(
    searchParams.get("order") || location.state?.orderID || ""
  );

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  //載入訂單明細
  useEffect(() => {
    let alive = true;
    if (!orderID) {
      setError("查無此訂單");
      setLoading(false);
      return;
    }
    UserService.getOrderDetail(orderID)
      .then((res) => {
        if (!alive) return;
        if (res.data?.status && res.data?.data) {
          setOrder(res.data.data);
        } else {
          setError(res.data?.message || "查無此訂單");
        }
      })
      .catch(() => {
        if (alive) setError("讀取訂單明細失敗");
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [orderID]);

  //明細卡（web / mobile 共用）
  const renderCard = () => {
    if (loading) return <Loading />;
    if (error || !order) {
      return (
        <div className="detail-card">
          <span className="detail-empty">{error || "查無此訂單"}</span>
        </div>
      );
    }
    return (
      <div className="detail-card">
        <div className="order-status">
          <span>{STATUS_LABEL[order.status] || order.status}</span>
          <span className="number">共 1 項商品</span>
        </div>

        <div className="order-line"></div>

        <div className="order-info">
          <div className="item-info">
            <span className="item-title">訂單編號</span>
            <span>{order.orderID}</span>
          </div>
          <div className="item-info">
            <span className="item-title">建立時間</span>
            <span>{formatTime(order.createdAt)}</span>
          </div>
          <div className="item-info">
            <span className="item-title">付款總額</span>
            <span className="order-amout">{`NT$${order.amount}`}</span>
          </div>
        </div>

        <div className="product-list">
          <div className="item-product">
            <div className="product-holder">
              <img src={getProductImage(order.planID)} alt="" />
            </div>
            <div className="product-detail">
              <span className="name">
                {order.productName || order.planID}
              </span>
              <span>1 件</span>
              <span>{`NT$${order.amount}`}</span>
            </div>
          </div>
        </div>

        <span className="service-mail">客服信箱</span>
      </div>
    );
  };

  return (
    <div className="purchase-detail-page">
      {/* 電腦板佈局 */}
      {!isMobile && (
        <div
          className="web-main"
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
        >
          <div className="content">
            <div className="title">
              <img src="../images/ic-records.png" alt="" />
              <span>購買記錄</span>
            </div>
            {renderCard()}
          </div>

          <div className="divide"></div>

          {/*隱私政策與聯絡官方*/}
          <SiteFooter />
        </div>
      )}

      {/* 移動裝置佈局 */}
      {isMobile && (
        <div className="mobile-main">
          <div className="content">
            <div className="title">
              <img src="../images/ic-records.png" alt="" />
              <span>購買記錄</span>
            </div>
            {renderCard()}
          </div>

          <div className="divide"></div>

          <SiteFooter />
        </div>
      )}
    </div>
  );
};

export default PurchaseDetailCompontent;
